@if (data$ | async; as data) {
  <div class="conversation">
    <header class="conversation__header" [ngClass]="{ 'conversation__header--with-padding': !data.isNavShown }">
      @if (data.isNavShown) {
        <cv-query-navigation class="conversation__header-navigation" />
      } @else {
        <img ngSrc="assets/icons/logo.svg" priority alt="logo" height="29" width="160" />
        <cv-conversation-ids
          [ids]="data.applicationState.conversationIDs.data"
          [currentId]="data.applicationState.dataQueryParam"
        />
      }
    </header>

    <main
      class="conversation__content"
      [ngClass]="{ 'conversation__content--no-scroll': data.isNavShown && !data.isScreenLarge }"
    >
      <div class="conversation__print-view">
        <cv-transcriptions class="splitter-content p-20" />
      </div>
      @if (data.isScreenLarge) {
        <p-splitter
          styleClass="full-height"
          [ngClass]="{ 'conversation__review-mode-splitter': data.isReviewMode }"
          [panelSizes]="data.isReviewMode ? [60, 40] : [50, 50]"
        >
          @if (!data.isReviewMode) {
            <ng-template pTemplate>
              <cv-transcriptions class="splitter-content p-20" />
            </ng-template>
          }
          <ng-template pTemplate>
            <div class="splitter-content p-20" [@routeAnimations]="page.activatedRouteData['animation']">
              <router-outlet #page="outlet" />
            </div>
          </ng-template>

          @if (data.isReviewMode) {
            <ng-template pTemplate>
              <cv-transcriptions class="splitter-content p-20" />
            </ng-template>
          }
        </p-splitter>
      } @else {
        <cv-conversation-mobile-view />
      }
    </main>
  </div>
}
